import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "./App.css";
import LogIn from "./components/auth/LogIn";
import Home from "./components/Home";
import Administrar from "./components/administrar/Administrar";
import Metricas from "./components/metricas/Metricas";
import Reciba from "./components/reciba/Reciba";
import Almacen from "./components/almacen/Almacen";
import PProduccion from "./components/produccion/PProduccion";
import Planeacion from "./components/planeacion/Planeacion";
import PlaneacionB from "./components/planeacion/PlaneacionB";
import Calidad from "./components/calidad/Calidad";
import Usuarios from "./components/usuarios/Usuarios";
import Clientes from "./components/clientes/Clientes";
import Productos from "./components/productos/Productos";
import Test from "./components/codereader/Qrreqder";
import BTest from "./components/codereader/barcodereader";
import QRGenerator from "./components/codereader/Qrgenerator";
import Bargenerator from "./components/codereader/barcodegenerator";
import Focus from "./components/codereader/focus";
import Embarques from "./components/embarques/Embarques";
import Ubicacion from "./components/ubicacion/Ubicacion";
import Esqueleto from "./components/esqueleto/Esqueleto";
import Tickets from "./components/tickets/tickets";
import Cotizacion from "./components/cotizacion/Cotizacion";
import GeneradorQR from "./components/codereader/GeneradorQR";
import Facturacion from "./components/facturacion/Facturacion";
import Compras from "./components/compras/Compras";
// App.js
function App() {
  return (
    <div className="App">
      <Router>
        <Switch>
          <Route exact path="/" component={LogIn} />
          <Route exact path="/home" component={Home} />
          <Route exact path="/login" component={LogIn} />
          <Route exact path="/administrar" component={Administrar} />
          <Route exact path="/metricas" component={Metricas} />
          <Route exact path="/reciba" component={Reciba} />
          <Route exact path="/almacen" component={Almacen} />
          <Route exact path="/planeacion" component={Planeacion} />
          <Route exact path="/planeacionb" component={PlaneacionB} />
          <Route exact path="/pproduccion" component={PProduccion} />
          <Route exact path="/calidad" component={Calidad} />
          <Route exact path="/usuarios" component={Usuarios} />
          <Route exact path="/embarques" component={Embarques} />
          <Route exact path="/facturacion" component={Facturacion} />
          <Route exact path="/clientes" component={Clientes} />
          <Route exact path="/cotizaciones" component={Cotizacion} />
          <Route exact path="/productos" component={Productos} />
          <Route exact path="/compras" component={Compras} />
          <Route exact path="/ubicacion" component={Ubicacion} />
          <Route exact path="/qrreader" component={Test} />
          <Route exact path="/brreader" component={BTest} />
          <Route exact path="/generarqr" component={QRGenerator} />
          <Route exact path="/generarbc" component={Bargenerator} />
          <Route exact path="/esqueleto" component={Esqueleto} />
          <Route exact path="/focus" component={Focus} />
          <Route exact path="/tickets" component={Tickets} />
          <Route exact path="/generarqrt" component={GeneradorQR} />
        </Switch>
      </Router>
    </div>
  );
}

export default App;
